import React from 'react';
import { IProps } from './index.types';
import { ColumnStyle } from './index.styled';

const ColumnStyled: React.FC<IProps> = ({ width, children }) => {
  return <ColumnStyle width={width}>{children}</ColumnStyle>;
};

export default ColumnStyled;
